import React, { useEffect, useState } from "react";
import {
  DateInput,
  TextInput,
  SelectInput,
} from "../../components/common/ui/Inputs/index.js";
import Button from "../../components/common/ui/Button.jsx";
import Table from "../../components/common/table/Table.jsx";
import { showToastNotification } from "../../components/common/ui/NotificationModal/ToastNotication.js";
import { history } from "../../_helpers/index.js";
import ExcelExport from "../../components/common/ui/Export/ExcelExport.jsx";
import generateXlsx from "../../components/common/export/generateXlsx.js";
import deleteicon from "../../assets/svg/delete-icon.svg";
import downloadicon from "../../assets/svg/download.svg";
import ApprovedIcon from "../../assets/svg/approved.svg";
import PendingIcon from "../../assets/svg/pending-user.svg";
import RejectIcon from "../../assets//svg/deactiveate-user.svg";
import { useDispatch, useSelector } from "react-redux";
import { authActions, postalMailActions } from "../../_store/index.js";
import { Popup } from "../../components/common/ui/NotificationModal/Popup.js";
import CustomLoader from "../../components/common/ui/Loader.jsx";
import {
  fDate,
  formatDateTimeAMPM,
  getCurrentDate,
  getPastDate,
  MinDate,
  Today,
} from "../../utils/formatTime.js";
import { masterActions } from "./../../_store/master.slice";
import { StoredProcedures } from "../../_helpers/enumerator";
import Swal from "sweetalert2";
import AddIcon from "../../assets/svg/btn_icons/create-btn-icon.svg";
import useManagementUserAccessPermission from "../../hooks/useManagementUserAccessPermission.jsx";
import { useNavigate } from "react-router-dom";

function PostalMail() {
  const {
    facilityInPostalMail: facilityCode,
    postalMail,
    postalMailList,
    firstNameOptions,
    lastNameOptions,
    postalMailFullList,
    deleteDocResponse,
    initialPostalMail,
    loading,
  } = useSelector((x) => x.postalMail);
  const [isloading, setisloading] = React.useState(false);
  const { user, commonFacilityCode } = useSelector((x) => x.auth);

  const { isPageReload: isPageReloading, isDashboardPage, isBacktoDashboard } = useSelector((state) => state.master);
  const [showSearchFields, setShowSearchFields] = useState(false);
  let PostalMailSearch = { ...postalMail };
  //Management User Access Permission selector
  const { PostalMailAccessPermission } = useManagementUserAccessPermission();

  // Hide or Show Upload btn
  const shouldShowBtnUpload =
    Array.isArray(PostalMailAccessPermission) && PostalMailAccessPermission.length > 0
      ? PostalMailAccessPermission.some(
        (item) =>
          item?.SubMenuName === "Upload" && item?.SubMenuActiveStatus === 1
      )
      : true;

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const isSignalRData = useSelector((state) => state?.auth?.isSignalRData);


  useEffect(() => {
    dispatch(
      postalMailActions.LoadFacilityDropdown(
        user.ManagementUserID === 1 ? 0 : user.ManagementUserID
      )
    );

  }, [dispatch, isPageReloading]);

  useEffect(() => {

    switch (deleteDocResponse?.IsSucceed) {
      case 1:
        const searchParams = { ...PostalMailSearch };
        // searchParams.pageNo = 1;
        // searchParams.rowCountPerPage = 10;
        // dispatch(postalMailActions.setPostalMail(searchParams));
        dispatch(postalMailActions.LoadPostalMailList({ ...searchParams, managementUserID: user.ManagementUserID }))
          .then((result) => {
            if (result?.payload?.DataList?.length === 0) {
              const searchData = { ...PostalMailSearch };
              searchData.pageNo = 1;
              searchData.rowCountPerPage = 10;
              dispatch(postalMailActions.setPostalMail(searchData));
              dispatch(postalMailActions.LoadPostalMailList({ ...searchData, managementUserID: user.ManagementUserID }));
            }
          })
          .catch((err) => { });
        showToastNotification("Document Deleted successfully", "success");
        dispatch(postalMailActions.clearDeleteResponse());
        break;
      case -1:
        dispatch(postalMailActions.LoadPostalMailList({ ...PostalMailSearch, managementUserID: user.ManagementUserID }));
        showToastNotification("Something went wrong. Please try again");
        dispatch(postalMailActions.clearDeleteResponse());
        break;
      case -2:
        dispatch(postalMailActions.LoadPostalMailList({ ...PostalMailSearch, managementUserID: user.ManagementUserID }));
        showToastNotification("This postal document has already been approved");
        dispatch(postalMailActions.clearDeleteResponse());
        break;
      case -3:
        dispatch(postalMailActions.LoadPostalMailList({ ...PostalMailSearch, managementUserID: user.ManagementUserID }));
        showToastNotification("This postal document has already been rejected");
        break;
      case -4:
        dispatch(postalMailActions.LoadPostalMailList({ ...PostalMailSearch, managementUserID: user.ManagementUserID }));
        showToastNotification("This postal document has already been deleted");
        dispatch(postalMailActions.clearDeleteResponse());
        break;
      default:
        break;
    }
  }, [deleteDocResponse]);

  useEffect(() => {
    // if (PostalMailSearch.rowCountPerPage > 10 || PostalMailSearch.pageNo > 1) {

    const searchData = { ...PostalMailSearch };
    if (isDashboardPage) {
      searchData.fromDate = "01/01/2017";
      searchData.pageNo = 1;
      searchData.facilityID = commonFacilityCode;
      searchData.rowCountPerPage = 10;
      dispatch(postalMailActions.setPostalMail(searchData));
      dispatch(postalMailActions.GetPostalMailAccessibleInmateLastName({ facilityID: commonFacilityCode, firstName: "", }));
      dispatch(postalMailActions.GetPostalMailAccessibleInmateFirstName({ facilityID: commonFacilityCode, lastName: "", }));
    }
    dispatch(postalMailActions.LoadPostalMailList({ ...searchData, managementUserID: user.ManagementUserID, }));
    // }
  }, [isDashboardPage]);

  useEffect(() => {
    if (postalMailFullList && postalMailFullList?.DataList?.length > 0) {
      const title = "PostalMail_Documents_List";
      const generateExcelColumns = getExcelColumns();
      const PostalMail_Documents_List = transformDataForExcel(
        postalMailFullList?.DataList || []
      );

      try {
        generateXlsx(PostalMail_Documents_List, generateExcelColumns, title);
        dispatch(postalMailActions.clearpostalMailFullList());
      } catch (error) {
        console.error("Error generating Excel file:", error);
      }
    }
  }, [postalMailFullList]);

  // Helper function to get Excel columns
  const getExcelColumns = () => [
    "Inmate ID",
    "Inmate Name",
    "Facility Code",
    "Mail From",
    "Uploaded From",
    "Uploaded Date",
    "Read Date",
    "Status",
  ];

  // Helper function to transform data for Excel
  const transformDataForExcel = (dataList) =>
    dataList.map((obj) => ({
      InmateResidentId: obj.InmateResidentId,
      InmateFullName: obj.InmateFullName,
      FacilityCode: obj.FacilityCode,
      MailFrom: obj.MailFrom,
      UploadedFrom: obj.UploadedFrom,
      CreatedDate: obj.CreatedDate,
      InmateReadDate: formatDateTimeAMPM(obj.InmateReadDate),
      ApproveStatus: obj.ApproveStatus,
    }));

  const [showUploadForm, setShowUploadForm] = useState(false);
  const [selectedInmateId, setSelectedInmateId] = useState(null);
  const [pdfFile, setPdfFile] = useState(false);

  //Download Doc
  // const handleDocDownload = (row) => {
  //   const documentPath = row?.DocumentPath; // Example: "/PostalMail/MS01/ps_110129.pdf"

  //   // Extract the folder path
  //   const extractedFolderPath = documentPath?.split("/").slice(1, -1).join("/");

  //   // Extract the file name
  //   const filename = documentPath?.split("/").pop();

  //   if (extractedFolderPath && filename) {
  //     dispatch(
  //       masterActions.DownLoadFiles({
  //         filename,
  //         folderPath: extractedFolderPath,
  //       })
  //     );
  //   } else {
  //     console.error("Invalid document path");
  //   }
  // };

  const handleDocDownload = async (row) => {
    const documentPath = row?.DocumentPath; // Example: "/PostalMail/MS01/ps_110129.pdf"

    // Extract the folder path
    const extractedFolderPath = documentPath?.split("/").slice(1, -1).join("/");

    // Extract the file name
    const filename = documentPath?.split("/").pop();

    if (extractedFolderPath && filename) {
      try {
        setisloading(true);
        const result = await dispatch(
          masterActions.DownLoadFiles({
            filename,
            folderPath: extractedFolderPath,
          })
        ).unwrap();

        if (result.success) {
          setisloading(false)
        }
      } catch (error) {
        setisloading(false)
        console.error("Download failed:", error.message);
        showToastNotification(
          "File does not exist in the uploaded directory",
          "error"
        ); // Show error toast
      }
    } else {
      console.error("Invalid document path");
      showToastNotification("Invalid document path", "error"); // Show error toast for invalid path
    }
  };

  const getCurrentDateTime = () => {
    const utcNow = new Date();

    // Convert UTC time to Eastern Time
    const options = { timeZone: "America/New_York" };
    const easternDate = new Date(utcNow.toLocaleString("en-US", options));

    // Format the date as MM/dd/yyyy HH:mm:ss
    const month = String(easternDate.getMonth() + 1).padStart(2, "0");
    const day = String(easternDate.getDate()).padStart(2, "0");
    const year = easternDate.getFullYear();

    const hours = String(easternDate.getHours()).padStart(2, "0");
    const minutes = String(easternDate.getMinutes()).padStart(2, "0");
    const seconds = String(easternDate.getSeconds()).padStart(2, "0");

    const formattedTime = `${month}/${day}/${year} ${hours}:${minutes}:${seconds}`;
    return formattedTime;
  };

  const handlePostalMailList = () => {
    PostalMailSearch.managementUserID = user.ManagementUserID;
    PostalMailSearch.isNoLoading = true
    dispatch(postalMailActions.LoadPostalMailList({ ...PostalMailSearch, managementUserID: user.ManagementUserID }));
  }

  // SignalR
  useEffect(() => {

    switch (isSignalRData?.type) {
      // case 'Send_PostalMail':
      //   if (isSignalRData?.message?.CreatedBy != user.ManagementUserID) {
      //     handlePostalMailList();
      //   }
      //   break;
      case 'Read_PostalMail':
        var updatedList = postalMailList?.DataList?.map((item) => {
          if (item?.MailScanningDocumentID === isSignalRData.message.MailScanningDocumentID && item?.InmateReadDate == null) {
            return {
              ...item,
              InmateReadDate: getCurrentDateTime(),
            };
          }
          return item
        })
        dispatch(postalMailActions?.setPostalMailList({ DataList: updatedList, TotalRecordCount: postalMailList?.TotalRecordCount }));
        break;
      // case 'Admin_ApproveOrReject_PostalMail_Request':
      //   if (isSignalRData?.message?.modifiedBy != user.ManagementUserID) {
      //     handlePostalMailList();
      //   }
      //   break;
    }

  }, [isSignalRData]);

  const handleDelete = (row) => {
    Popup({
      title: "Message",
      text: `Are you sure you want to delete?`,
      icon: "info",
      confirmButtonText: "YES",
      cancelButtonText: "NO",
      // onConfirm: () => dispatch(documentsActions.DeleteDocument(payload)),
      onConfirm: () => {
        dispatch(
          postalMailActions.DeletePostalMail({
            mailScanningDocumentID: row.MailScanningDocumentID,
            modifiedBy: user.ManagementUserID,
          })
        );
        // Insert Management User Activity Log
        dispatch(
          authActions?.ManagementUserActivityLog({
            ManagementUserID: user?.ManagementUserID,
            facilityID: commonFacilityCode,
            ProcedureName: StoredProcedures?.ApproveorRejectMailDocument,
            UserAction: `Deleted a Postal Mail Document (MailScanningDocumentID - ${row?.UspApproveorRejectMailDocument})`,
          })
        );
      },
    });
  };
  const pdfPath = `${process.env.PUBLIC_URL}/pdfs/file-example_PDF_1MB`;

  const handleInmateClick = (id) => {
    setSelectedInmateId(id);
    setPdfFile(pdfPath[id]); // Load corresponding PDF file
    setPdfFile(true);
  };

  // const formatDate = (dateString) => {
  //   const date = new Date(dateString);
  //   return new Intl.DateTimeFormat("en-US", {
  //     month: "2-digit",
  //     day: "2-digit",
  //     year: "numeric",
  //     hour: "2-digit",
  //     minute: "2-digit",
  //     hour12: true,
  //   })
  //     .format(date)
  //     .replace(",", "");
  // };

  const formatDate = (dateString) => {
    if (!dateString) return "-";
    const date = new Date(dateString);
    return new Intl.DateTimeFormat("en-US", {
      month: "2-digit",
      day: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    })
      .format(date)
      .replace(",", "");
  };

  const columns = [
    {
      name: "Inmate ID",
      key: "InmateResidentId",
      selector: (row) => row.InmateResidentId,
      cell: (row) => (
        <div className="d-flex flex-wrap gap-2">
          <div
            className="Common_Link_Style "
            onClick={() => handleUserClick(row)}
          >
            {row.InmateResidentId}
          </div>
          {row.ApproveStatus === "Pending" && (
            <div class="newbutton-container">
              New
              <div class="border-animation"></div>
            </div>
          )}
        </div>
      ),
      sortable: true,
    },
    {
      name: "Inmate Name",
      key: "InmateFullName",
      selector: (row) => row.InmateFullName,
      sortable: true,
    },
    {
      name: "Facility Code",
      key: "FacilityCode",
      selector: (row) => row.FacilityCode,
      sortable: true,
    },
    {
      name: "Mail From",
      key: "MailFrom",
      selector: (row) => row.MailFrom,
      sortable: true,
    },
    {
      name: "Uploaded From",
      key: "UploadedFrom",
      selector: (row) => row.UploadedFrom,
      sortable: true,
    },
    {
      name: "Uploaded Date",
      key: "CreatedDate",
      selector: (row) => row.CreatedDate,
      cell: (row) => (
        <div className="d-flex flex-wrap ">
          <div className="font-size-13 fw-500 ">
            {formatDate(row?.CreatedDate)}
          </div>
        </div>
      ),
      sortable: true,
    },
    {
      name: "Read Date",
      key: "InmateReadDate",
      selector: (row) =>
        row.InmateReadDate ? formatDateTimeAMPM(row.InmateReadDate) : "-",
      cell: (row) => (
        <div className="d-flex flex-wrap ">
          <div className="font-size-13 fw-500 ">
            {formatDate(row?.InmateReadDate)}
          </div>
        </div>
      ),
      sortable: true,
    },
    {
      width: "80px",
      name: "Status",
      key: "ApproveStatus",
      selector: (row) => row.ActiveStatus,
      sortable: true,
      cell: (row) => (
        <div>
          <img
            title={row.ApproveStatus}
            src={
              row.ApproveStatus === "Approved"
                ? ApprovedIcon
                : row.ApproveStatus === "Pending"
                  ? PendingIcon
                  : row.ApproveStatus === "Rejected"
                    ? RejectIcon
                    : ""
            }
            alt={row.ApproveStatus}
            className="in-icon-size"
          />
        </div>
      ),
    },

    {
      width: "80px",
      name: "Action",
      selector: (row) => (
        <div className="d-flex flex-wrap gap-2">
          <img
            className="in-icon-size cursor-pointer"
            src={downloadicon}
            title="Download"
            alt="Download" // Added alt text for accessibility
            aria-hidden="true"
            onClick={() => handleDocDownload(row)} // Uncommented if needed
          />
          {row.ApproveStatus !== "Approved" &&
            row.ApproveStatus !== "Rejected" && (
              <img
                className="in-icon-size cursor-pointer"
                src={deleteicon}
                title="Delete"
                alt="Delete"
                aria-hidden="true"
                onClick={() => handleDelete(row)}
              />
            )}
        </div>
      ),
      sortable: false,
    },
  ];

  const handleUserClick = (row) => {
    Swal?.close();
    dispatch(masterActions.UpdateisDashboardPage(false));
    dispatch(postalMailActions?.clearDownloadFileResponse());
    dispatch(postalMailActions?.clearPostalMailInfo());
    history.navigate("/Admin/PostalMailList/View", {
      state: { MailScanningDocumentID: row.MailScanningDocumentID },
    });
  };

  // Status options
  const statusOptions = [
    { value: 3, label: "--ALL--" },
    { value: 0, label: "Pending" },
    { value: 1, label: "Approved" },
    { value: 2, label: "Rejected" },
  ];

  // Handle Search button click
  const handleSearch = (e) => {
    e?.preventDefault();
    PostalMailSearch.managementUserID = user.ManagementUserID;
    PostalMailSearch.pageNo = 1;
    PostalMailSearch.rowCountPerPage = 10;
    dispatch(postalMailActions.setPostalMail(PostalMailSearch));
    dispatch(postalMailActions.LoadPostalMailList({ ...PostalMailSearch, managementUserID: user.ManagementUserID }));
  };

  // Handle Reset button click
  const handleReset = () => {
    dispatch(postalMailActions.clearPostalMail());
    dispatch(postalMailActions.clearSearchPostalMail());
    dispatch(
      postalMailActions.LoadPostalMailList({
        ...initialPostalMail,
        managementUserID: user.ManagementUserID,
      })
    );
  };

  // Handle Upload Mail button click
  const handleUpload = () => {
    Swal?.close();
    const shouldShowBtnUploads =
      Array.isArray(PostalMailAccessPermission) && PostalMailAccessPermission?.length > 0
        ? PostalMailAccessPermission?.some(
          (item) =>
            item?.SubMenuName === "Upload" &&
            item?.SubMenuActiveStatus === 1
        )
        : true;
    if (!shouldShowBtnUploads) {
      showToastNotification(
        "Upload mail option has been disabled by the admin.",
        "error"
      );
      return;
    }
    history.navigate("/Admin/PostalMailList/Add");
    setShowUploadForm(true);

  };

  const handleSelectChange = (selectedOption, name) => {
    const updatedSearch = { ...PostalMailSearch };
    updatedSearch.managementUserID = user.ManagementUserID;
    updatedSearch.pageNo = 1;
    updatedSearch.rowCountPerPage = 10;
    const loadPostalMailList = () => {
      dispatch(postalMailActions.LoadPostalMailList({ ...updatedSearch, managementUserID: user.ManagementUserID }));
    };

    const handleFacilityID = () => {
      updatedSearch[name] = selectedOption?.value || 0;

      updatedSearch.lastName = "";
      updatedSearch.firstName = "";
      updatedSearch.firstNameValue = 0;
      updatedSearch.lastNameValue = 0;

      dispatch(
        postalMailActions.GetPostalMailAccessibleInmateLastName({
          facilityID: updatedSearch[name],
          firstName: "",
        })
      );
      dispatch(
        postalMailActions.GetPostalMailAccessibleInmateFirstName({
          facilityID: updatedSearch[name],
          lastName: "",
        })
      );
      loadPostalMailList();
    };

    const handleIsApprove = () => {
      updatedSearch[name] = selectedOption?.value || 0;
      loadPostalMailList();
    };

    const handleFirstName = () => {
      updatedSearch[name] =
        selectedOption?.value > 0 ? selectedOption?.label : "";
      updatedSearch.firstNameValue = selectedOption?.value || 0;
      // if (selectedOption?.value > 0) {
      // dispatch(
      //   postalMailActions.GetPostalMailAccessibleInmateLastName({
      //     facilityID: updatedSearch.facilityID,
      //     firstName: updatedSearch.firstName,
      //   })
      // );
      // }
      loadPostalMailList();
    };

    const handleLastName = () => {
      updatedSearch[name] =
        selectedOption?.value > 0 ? selectedOption?.label : "";
      updatedSearch.lastNameValue = selectedOption?.value || 0;

      updatedSearch.firstName = "";
      updatedSearch.firstNameValue = 0;

      dispatch(
        postalMailActions.GetPostalMailAccessibleInmateLastName({
          facilityID: updatedSearch.facilityID,
          firstName: updatedSearch.firstName,
        })
      );

      // if (selectedOption?.value > 0) {
      dispatch(
        postalMailActions.GetPostalMailAccessibleInmateFirstName({
          facilityID: updatedSearch.facilityID,
          lastName: updatedSearch.lastName,
        })
      );
      // }
      loadPostalMailList();
    };

    switch (name) {
      case "facilityID":
        handleFacilityID();
        break;

      case "isApprove":
        handleIsApprove();
        break;

      case "firstName":
        handleFirstName();
        break;

      case "lastName":
        handleLastName();
        break;

      default:
        console.warn(`Unhandled field name: ${name}`);
    }

    dispatch(postalMailActions.setPostalMail(updatedSearch));
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    // Allow numbers only by filtering non-numeric characters
    const numericValue = value.replace(/[^0-9]/g, "");

    PostalMailSearch[name] = numericValue;
    dispatch(postalMailActions.setPostalMail(PostalMailSearch));
  };

  const handleDateChange = (name, value) => {
    // const minDate = MinDate();
    // const valueDate = new Date(value);
    // const date = valueDate > minDate ? fDate(value) : "";
    const date = fDate(value);
    PostalMailSearch[name] = date;

    dispatch(postalMailActions.setPostalMail(PostalMailSearch));
  };

  //Click the Enter Btn need to select the Current Date
  const handleDateEnterKey = (event, name) => {
    if (event.key === "Enter" && PostalMailSearch[name] === "") {
      const currentDate = new Date();

      // Set today's date using the same logic as your handleDateChange
      handleDateChange(name, currentDate);
    }

    const regex = /^[0-9/]$/; // Allow numbers and "/"

    if (
      !regex.test(event.key) &&
      event.key !== "Backspace" &&
      event.key !== "Delete" &&
      !(event.ctrlKey && event.key === "v")
    ) {
      event.preventDefault();
    }

    // Auto-insert '/' when typing
    const input = event.target.value;

    if (event.key !== "Backspace" && event.key !== "Delete") {
      if (input?.length === 2 || input?.length === 5) {
        event.target.value = input + "/";
      }
    }
  };

  const handleDateBlur = (e, fieldName) => {
    let { value } = e.target;
    let isFromValid = true;
    let isToValid = true;

    if (fieldName === "fromDate") {
      if (
        PostalMailSearch.toDate &&
        new Date(value) > new Date(PostalMailSearch.toDate)
      ) {
        // Invalid: FromDate cannot be after ToDate
        isFromValid = false;
      }
    } else if (fieldName === "toDate") {
      if (
        PostalMailSearch.fromDate &&
        new Date(value) < new Date(PostalMailSearch.fromDate)
      ) {
        // Invalid: ToDate cannot be before FromDate
        isToValid = false;
      }
    }

    // Define date format used
    const minDate = MinDate();
    const today = Today();
    const valueDate = new Date(value);
    const isValidDate = valueDate >= minDate && valueDate <= today;

    let updatedParam = {
      ...PostalMailSearch,
      fromDate:
        fieldName === "fromDate"
          ? isFromValid && isValidDate
            ? value
            : ""
          : PostalMailSearch.fromDate, // preserve existing value
      toDate:
        fieldName === "toDate"
          ? isToValid && isValidDate
            ? value
            : ""
          : PostalMailSearch.toDate, // preserve existing value
    };
    dispatch(postalMailActions.setPostalMail(updatedParam));
  };

  //Pagination
  const handlePageChange = (value) => {
    if (isSorting) {
      isSorting = false;
      return;
    }
    // PostalMailSearch.pageNo = value;
    // dispatch(postalMailActions.setPostalMail(PostalMailSearch));
    const updatedPostalMail = { ...postalMail, pageNo: value };
    dispatch(postalMailActions.setPostalMail(updatedPostalMail));
    dispatch(postalMailActions.LoadPostalMailList({ ...updatedPostalMail, managementUserID: user.ManagementUserID }));

  }; // Call API when page changes

  const handleRowPerPage = (value) => {
    // PostalMailSearch.rowCountPerPage = value;
    // dispatch(postalMailActions.setPostalMail(PostalMailSearch));

    const updatedPostalMail = {
      ...postalMail,
      pageNo: 1,
      rowCountPerPage: value,
    };
    dispatch(postalMailActions.setPostalMail(updatedPostalMail));
    dispatch(postalMailActions.LoadPostalMailList({ ...updatedPostalMail, managementUserID: user.ManagementUserID }));
  };

  const handleClickExcel = () => {
    const updateTotalRows = {
      ...PostalMailSearch,
      PageNo: 1,
      rowCountPerPage: postalMailList?.TotalRecordCount,
      exportExcel: true, // Flag to indicate Excel export
    };

    if (postalMailList?.TotalRecordCount > 10) {
      dispatch(postalMailActions.LoadPostalMailList({ ...updateTotalRows, managementUserID: user.ManagementUserID }));
    } else {
      const title = "PostalMail_Documents_List";
      const generateExcelColumns = getExcelColumns();
      const PostalMail_Documents_List = transformDataForExcel(
        postalMailList?.DataList || []
      );

      try {
        generateXlsx(PostalMail_Documents_List, generateExcelColumns, title);
        dispatch(postalMailActions.clearpostalMailFullList());
      } catch (error) {
        console.error("Error generating Excel file:", error);
      }
    }
  };

  let isSorting = false;
  const handleSort = (column, sortDirection) => {
    if (!column?.key) return;
    isSorting = true;
    const search = { ...PostalMailSearch };
    const newSortOrder = search.sortField.includes(column.key)
      ? search.sortField.endsWith("asc")
        ? "desc"
        : "asc"
      : "asc";

    search.sortField = `${column.key} ${newSortOrder}`;
    dispatch(postalMailActions.setPostalMail(search));
    dispatch(
      postalMailActions.LoadPostalMailList({
        ...PostalMailSearch,
        managementUserID: user?.ManagementUserID,
        sortField: `${column.key} ${newSortOrder}`,
      })
    );
  };

  if (loading || isloading) {
    return <CustomLoader />;
  }

  const toggleInformation = () => {
    setShowSearchFields((prev) => !prev);
  };
  const handleBack = () => {
    navigate("/Admin/Dashboard");
  }


  const renderSearch = () => {
    return (
      <form>
        <div className="row">
          <div className="col-sm-6 col-md-6 col-lg-3">
            <div className="form-floating mb-3">
              <SelectInput
                name="facilityID"
                label="Facility Code"
                options={facilityCode}
                value={PostalMailSearch?.facilityID}
                handleChange={(selectedOption) =>
                  handleSelectChange(selectedOption, "facilityID")
                }
                isMulti={false}
                isClearable={PostalMailSearch?.facilityID !== 0}
              />
            </div>
          </div>
          <div className="col-sm-6 col-md-6 col-lg-3">
            <div className="form-floating mb-3">
              <TextInput
                name="inmateResidentID"
                label="Inmate ID"
                value={PostalMailSearch?.inmateResidentID}
                handleChange={(e) => handleChange(e)}
                placeholder="Enter Inmate ID"
                maxLength={18}
              />
            </div>
          </div>
          <div className="col-sm-6 col-md-6 col-lg-3">
            <div className="form-floating mb-3">
              <SelectInput
                name="lastName"
                label="Last Name"
                options={lastNameOptions}
                value={PostalMailSearch?.lastNameValue}
                handleChange={(selectedOption) =>
                  handleSelectChange(selectedOption, "lastName")
                }
                isMulti={false}
                isDisabled={!PostalMailSearch?.facilityID}
                isClearable={PostalMailSearch?.lastNameValue !== 0}
              />
            </div>
          </div>
          <div className="col-sm-6 col-md-6 col-lg-3">
            <div className="form-floating mb-3">
              <SelectInput
                name="firstName"
                label="First Name"
                options={firstNameOptions}
                value={PostalMailSearch?.firstNameValue}
                handleChange={(selectedOption) =>
                  handleSelectChange(selectedOption, "firstName")
                }
                isMulti={false}
                isDisabled={!PostalMailSearch?.facilityID}
                isClearable={PostalMailSearch?.firstNameValue !== 0}
              />
            </div>
          </div>
          {/* second row */}
          <div className="col-sm-6 col-md-6 col-lg-3">
            <div className="form-floating mb-3">
              <SelectInput
                name="isApprove"
                label="Status"
                options={statusOptions}
                value={PostalMailSearch?.isApprove}
                handleChange={(selectedOption) =>
                  handleSelectChange(selectedOption, "isApprove")
                }
                isMulti={false}
                isClearable={PostalMailSearch?.isApprove !== 0}
              />
            </div>
          </div>
          <div className="col-sm-6 col-md-6 col-lg-3">
            <div className="form-floating mb-3">
              <DateInput
                name="fromDate"
                label="From Date"
                maxDate={
                  PostalMailSearch?.toDate
                    ? PostalMailSearch?.toDate
                    : getCurrentDate()
                }
                value={PostalMailSearch?.fromDate || ""}
                handleChange={(date) => handleDateChange("fromDate", date)}
                isClearable={PostalMailSearch?.fromDate ? true : false}
                preventClear={!PostalMailSearch?.fromDate}
                minDate={new Date(2017, 0, 1)}
                handleBlur={(e) => handleDateBlur(e, "fromDate")}
                handleKeyDown={(e) => handleDateEnterKey(e, "fromDate")}
              />
            </div>
          </div>
          <div className="col-sm-6 col-md-6 col-lg-3">
            <div className="form-floating mb-3">
              <DateInput
                name="toDate"
                label="To Date"
                value={PostalMailSearch?.toDate}
                minDate={
                  PostalMailSearch?.fromDate
                    ? PostalMailSearch.fromDate
                    : new Date(2017, 0, 1)
                }
                maxDate={getCurrentDate()}
                handleChange={(date) => handleDateChange("toDate", date)}
                isClearable={PostalMailSearch?.toDate}
                preventClear={!PostalMailSearch?.toDate}
                handleBlur={(e) => handleDateBlur(e, "toDate")}
                handleKeyDown={(e) => handleDateEnterKey(e, "toDate")}
              />
            </div>
          </div>
        </div>

        <div className="mt-3 d-flex flex-wrap justify-content-center gap-3 flex-wrap">
          <Button
            className="me-2"
            label="Search"
            type="submit"
            status="primary"
            icon={"search"}
            onClick={handleSearch}
          />
          <Button
            className="me-2"
            label="Reset"
            type="button"
            status="secondary"
            onClick={handleReset}
            icon={"fa-solid fa-rotate-right"}
          />
        </div>
      </form>
    );
  };

  return (
    <div>
      <div className="d-flex flex-wrap flex-column justify-content-center align-items-center position-relative">
        <div className="card  shadow-sm b-r-all p-4 border border-dark-grey mt-3 w-100">
          {/* Mobile Only */}
          {isBacktoDashboard && (
            <div className="d-block d-md-none card shadow-sm b-r-all p-4 border border-dark-grey mt-3 w-100">
              <div className="d-flex justify-content-end">
                <Button
                  label="BACK To DashBoard"
                  type="button"
                  className="me-2"
                  onClick={() => handleBack()}
                  variant="danger"
                  status={"primary"}
                  icon={"fa-solid fa-angle-left"}
                  disabled={false}
                />
              </div>
            </div>
          )}

          {/* Mobile only (Below md breakpoint) */}
          <div className=" d-block d-md-none">
            <div
              className=" d-flex align-items-center justify-content-between"
              style={{ background: "transparent", cursor: "pointer" }}
              onClick={toggleInformation}
            >
              <h2 className="form_title_uppercase text-color">
                POSTAL MAIL SEARCH
              </h2>
              <i
                id="itagInformation"
                className={`fa fa-angle-down ${showSearchFields ? "rotate" : ""
                  }`}
                style={{ fontSize: "20px" }}
              ></i>
            </div>
          </div>
          {/* Mobile only (Below md breakpoint) */}
          <div className="d-block d-md-none mt-2">
            {showSearchFields && renderSearch()}
          </div>

          {/* Web only (Desktop and above) */}
          <div className="mb-3 d-none d-md-block">
            <div className="d-flex flex-wrap justify-content-between align-items-center flex-wrap resp-space ">
              <h2 className="form_title_uppercase text-color">
                {" "}
                POSTAL MAIL SEARCH
              </h2>

              {isBacktoDashboard && (
                <div className="d-flex flex-wrap gap-3">
                  <Button
                    label="BACK To DashBoard"
                    type="button"
                    className=" me-2"
                    onClick={() => handleBack()}
                    variant="danger"
                    status={"primary"}
                    icon={"fa-solid fa-angle-left"}
                    disabled={false}
                  />
                </div>
              )}
            </div>
          </div>
          {/* Web only (Desktop and above) */}
          <div className="d-none d-md-block">{renderSearch()}</div>
        </div>
        <div className="card  shadow-sm b-r-all p-4 border border-dark-grey mt-3 w-100 mb-4 ">
          <div className="d-flex flex-wrap justify-content-between align-items-center mb-3 resp-space">
            <h2 className="form_title_uppercase text-color">
              POSTAL MAILS LIST
            </h2>
            <div className="d-flex flex-wrap gap-3 align-items-center">
              {shouldShowBtnUpload && (
                <Button
                  variant="success"
                  className="me-2"
                  label="Upload Mail"
                  type="button"
                  // icon={"circle-plus"}
                  imgsrc={AddIcon}
                  status="btn-label"
                  onClick={handleUpload}
                />
              )}
              {postalMailList?.DataList?.length > 0 && (
                <ExcelExport handleExcelExport={handleClickExcel} />
              )}
            </div>
          </div>

          <Table
            columns={columns}
            data={postalMailList?.DataList}
            pagination={true}
            onChangePage={(e) => handlePageChange(e)} // Call API when page changes
            onChangeRowsPerPage={(e) => handleRowPerPage(e)}
            totalRowCount={postalMailList?.TotalRecordCount}
            currentPage={PostalMailSearch?.pageNo}
            paginationPerPage={PostalMailSearch?.rowCountPerPage}
            onSort={handleSort}
            serverSideSort
            sortColumn={PostalMailSearch?.sortField?.split(" ")[0]}
            sortDirection={PostalMailSearch?.sortField?.split(" ")[1]}
          />
        </div>
      </div>
      {/* )} */}
    </div>
  );
}

export default React.memo(PostalMail);
